import { Component, Input, OnInit } from '@angular/core';
import { PolicyDetails } from './view-models/policy-details.model';

@Component({
    selector: 'data-well',
    template: require('./data-well.component.html')
})
export class DataWellComponent {
    @Input() wellId: string;
    @Input() title: string;
    @Input() expanded: boolean;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/policy-edit/data-well.component.ts